<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol lg="3">
                <CInput
                  disabled
                  label="User"
                  invalid-feedback="User name should be filled"
                  required
                  v-model="$v.contactUsForm.user_code.$model"
                  :is-valid="!$v.contactUsForm.user_code.$invalid"
                />
              </CCol>

              <CCol lg="3">
                <CInput
                  disabled
                  label="Ticket Number"
                  invalid-feedback="User name should be filled"
                  v-model="$v.contactUsForm.ticket_number.$model"
                  :is-valid="!$v.contactUsForm.ticket_number.$invalid"
                />
              </CCol>
            </CRow>

             <CRow>
              <CCol sm="3">
                <CInput
                  disabled
                  label="Date Inserted"
                  invalid-feedback="Date Inserted should be filled"
                  required
                  v-model="contactUsForm.date_inserted"
                  :is-valid="!$v.contactUsForm.date_inserted.$invalid"
                />
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label for="contact_us">Status</label>
                  <model-select
                    class="form-control"
                    id="contact_us"
                    :options="contactUsStatusList"
                    v-model="$v.contactUsForm.status.$model"
                    :isError="$v.contactUsForm.status.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.contactUsForm.status.$invalid"
                    class="invalid-feedback-custom"
                  >Status should be filled.</div>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9">
              <label for="nik">Messages</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
              disabled
                :content="content"
                :options="editorOption"
                v-model="$v.contactUsForm.messages.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.contactUsForm.messages.$invalid" class="invalid-feedback-custom">
                Messages harus di isi.
              </div>
              <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.contactUsForm.description.$model"
                :is-valid="!$v.contactUsForm.description.$invalid"
              /> -->
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              title="Detail"
              :disabled="$v.contactUsForm.$invalid"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Response</template>
            <br />
            <!-- <RespondList
              :contactUs="contactUsForm"
              :contactUsData="contactUsDiscussion"
            ></RespondList> -->

            <RespondChat
              :contactUs="contactUsForm"
              :contactUsData="contactUsDiscussion"
            ></RespondChat>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";
import { required } from "vuelidate/lib/validators";
import RespondList from "./tabs/RespondList";
import RespondChat from "./tabs/RespondChat";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: "ContactUsDetails",
  components: { 
    GlobalTable, 
    Loading, 
    RespondList,
    RespondChat, 
    quillEditor,
  },
  data() {
    return {
      title: "Contact Us Detail",
      items: [],
      route:"",
      ticketNumber:"",
      contactUsDiscussion: [],
      contactUsStatusList:[],
      contactUsForm: tableInterfaces.contact_us,
      contactUsDiscussionForm: tableInterfaces.contact_us_discussion,
      isLoading: false,
      activeTab: 0,
      content: '',
      editorOption: {},
    };
  },
  validations: {
    contactUsForm: {
      user_code: { required },
      messages: { required },
      date_inserted: { },
      ticket_number:{ },
      status:{ },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDetailIssue(id);
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.contact_us) {
        tableInterfaces.contact_us[i] = null;
      }
      this.contactUsForm = tableInterfaces.contact_us;
    },
    getDetailIssue: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/master/contact_us/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.contactUsForm = response.data.data;
            // console.log(response.data.data);
            //this.contactUsForm.user_code = response.data.data.user_name;
            this.contactUsDiscussion = response.data.dataDetail;
            this.contactUsStatusList = response.data.contact_us_status;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/master/contact_us/update", this.contactUsForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Contact Us Update Status",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Contact Us Update Status");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.contactUsForm.description = html;
    },
  },

  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
    this.loadingRooms = false
    this.messagesLoaded = true
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
